import { format } from 'date-fns';

export let API_HOST = getApiHost()
export const SESSION_ID = getSessionId()

function getApiHost() {
  let defaultHost = 'https://staging-app.revibecollection.com';

  if (typeof window === 'undefined') {
    return defaultHost
  }
  return window.SERVER_DATA && window.SERVER_DATA.PUBLIC_HOST || defaultHost
}

function createSessionId() {
  const sessionId = Math.random().toString(36).slice(2);
  localStorage.setItem('rentalSessionId', sessionId);
  return sessionId;
}

function getSessionId() {
  return localStorage.getItem('rentalSessionId') ?? createSessionId();
}

export function formatDateRange(fromDate, toDate) {
  return `${ format(new Date(fromDate), 'dd') } ${ format(new Date(fromDate), 'LLL') } ${ format(new Date(fromDate), 'uuuu') } - ${ format(new Date(toDate), 'dd') } ${ format(new Date(toDate), 'LLL') } ${ format(new Date(toDate), 'uuuu')}`
}

export function getLowestPrice(SKUs) {
  let lowestPrice = ''
  let lowestPriceCurrency = ''
  for (const sku of SKUs) {
    if (sku.pricing) {
      for (const { price, currency } of sku.pricing) {
        if (Number(price) < Number(lowestPrice) || !lowestPrice) {
          lowestPrice = price
          lowestPriceCurrency = currency
        }
      }
    }
  }
  if (lowestPrice && lowestPriceCurrency) {
    return `${lowestPrice} ${lowestPriceCurrency}`
  }
  return lowestPrice
}

export function evalFunc(func, data) {
  try {
    const f = eval(func)
    f(data)         //{ product, SKUs, vendor }
    return true
  } catch (e) {
    // console.log('rntr: eval func error', e)
    return false
  }
}

export function makeReqUriFromLoc(loc) {
  const encoded = encodeURIComponent(loc)
  return `${API_HOST}/api/products/v2/by-location?url=${encoded}`
}
